import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container_home"
};
const _hoisted_2 = {
  class: "titelimg"
};
const _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_appHead = _resolveComponent("appHead");
  const _component_showproduct = _resolveComponent("showproduct");
  const _component_productindex = _resolveComponent("productindex");
  const _component_blankBottom = _resolveComponent("blankBottom");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_appHead, {
    index: 0
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $data.logotitle,
    alt: ""
  }, null, 8, _hoisted_3)]), _createVNode(_component_showproduct, {
    style: {
      "height": "25vh"
    }
  }), _createVNode(_component_productindex), _createVNode(_component_blankBottom)]);
}